
const uAgent = navigator.userAgent.toLowerCase()
function inAgent(str) {
  return uAgent.indexOf(str) !== -1
}

export const isWindows = inAgent('windows')
export const isIPhone = !isWindows && inAgent('iphone')
export const isIPod = inAgent('ipod')
export const isIPad = inAgent('ipad')
export const isIOS = isIPhone || isIPod || isIPad
// Google Search App (for IOS)
export const isGSA = inAgent('gsa') && isIOS
export const isIE = /msie|trident/.test(uAgent)
export const isEdge = inAgent('edge/')
export const isAndroid = inAgent('android')

export let hasPassiveEvents = false
if (typeof window !== 'undefined') {
  const passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true
      return undefined
    }
  } as any
  window.addEventListener('testPassive', null, passiveTestOptions)
  window.removeEventListener('testPassive', null, passiveTestOptions)
}

  /**
   * Returns whether or not device is mobile for responsive:
   */
export function isMobileDevice() {
  // ipads aren't mobile
  if (isIPad) {
    return false
  }

  // smaller than 736 is mobile
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height
  if (screenWidth <= 736) {
    return true
  } else if (screenWidth <= 1280 && Math.abs(window.orientation as number) === 90) {
    // Android landscape:
    return true
  } else if (screenWidth === 1080 && screenHeight === 1920 && window.orientation === 0) {
    // Galaxy S4 portrait:
    return true
  } else if (screenWidth === 1920 && screenHeight === 1080
    && Math.abs(window.orientation as number) === 90) {
    // Galaxy S4 landscape:
    return true
  }

  return false
}

/**
 * There are 4 breakpoints, 1-4, with 1 being smallest.
 * This returns which breakpoint applies for the current device.
 * NOTE: This will change with browser resize or orientation change.
 */
export function breakpoint() {
  const viewport = window.innerWidth
  // TODO: values are hard-coded until we have a way to load in the breakpoints.
  // Right now these are the same as what you will find in variables.scss
  if (viewport <= 569) {
    return 1
  } else if (viewport <= 849) {
    return 2
  } else if (viewport <= 1024) {
    return 3
  } else if (viewport <= 1200) {
    return 4
  }
  return 5
}

// Get the value of the cookie with cName, return null if it does not exist
export function getCookie(cName: string) {
  let value = null
  const ac = document.cookie
  let start = ac.indexOf(`${cName}=`)
  if (start >= 0) {
    start += cName.length + 1
    let end = ac.indexOf(';', start)
    if (end === -1) {
      end = ac.length
    }
    value = decodeURIComponent(ac.substring(start, end))
  }
  return value
}

export function dropCookie(cName: string) {
  setCookie(cName)
}

export function setCookie(cName: string, value = undefined, age: number = undefined) {
  let dc = `${cName}=`
  if (typeof value !== 'undefined') {
    dc += `${encodeURIComponent(value)}; path=/`
    if (typeof age !== 'undefined') {
      if (age !== -1) {
        const d = new Date()
        d.setTime(d.getTime() + (age * 1000))
        dc += `; Expires=${d.toUTCString()}`
      }
    }
  } else {
    // removes the cookie
    dc += `; path=/; Expires=${new Date(0).toUTCString()}`
  }
  document.cookie = dc
}

export function loadCss(href: string, id: string) {
  let cssNode = document.getElementById(id) as HTMLLinkElement
  if (!cssNode) {
    const head = document.getElementsByTagName('head')[0]
    cssNode = document.createElement('link')
    cssNode.id = id
    cssNode.type = 'text/css'
    cssNode.rel = 'stylesheet'
    cssNode.href = href
    cssNode.media = 'screen'
    head.appendChild(cssNode)
  } else {
    cssNode.href = href
  }
}

export function loadJs(src: string, id: string, defer = true, async = false): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const jsNode = document.createElement('script') as HTMLScriptElement
    jsNode.id = id
    jsNode.type = 'text/javascript'
    jsNode.src = src
    // using defer instead of async to guarantee order
    jsNode.defer = defer
    jsNode.async = async
    jsNode.charset = 'utf-8' // TT-12459
    jsNode.onload = () => resolve(true)
    jsNode.onerror = e => reject(e)
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(jsNode)
  })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/util/browser-utils.ts